import { c as _c } from "react/compiler-runtime";
import { Avatar, FontWeights } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { useMemo } from "react";
/** Defines the style for icons where the avatar has large size. */
export const ICON_LARGE_STYLE = {
  width: "31px",
  height: "31px"
};

/** Defines the style for icons where the avatar has small size. */
export const ICON_SMALL_STYLE = {
  width: "16px",
  height: "16px"
};
export function SphereAvatar(t0) {
  const $ = _c(62);
  const {
    initials: t1,
    src,
    icon,
    iconColor: t2,
    backgroundColor,
    size: t3,
    shouldUseSimplifiedAvatar: t4,
    shouldHideWhiteRim: t5
  } = t0;
  const initials = t1 === undefined ? "" : t1;
  const iconColor = t2 === undefined ? PALETTE_VARS.common.white : t2;
  const size = t3 === undefined ? "small" : t3;
  const shouldUseSimplifiedAvatar = t4 === undefined ? true : t4;
  const shouldHideWhiteRim = t5 === undefined ? false : t5;
  let t6;
  bb0: {
    if (size === "x-small") {
      const isInset = shouldHideWhiteRim && !shouldUseSimplifiedAvatar;
      const t7 = initials.length <= 2 ? "8px" : "6px";
      const t8 = shouldHideWhiteRim && !isInset ? "20px" : "16px";
      const t9 = isInset ? "2px" : 0;
      const t10 = shouldHideWhiteRim ? "0" : "16px";
      const t11 = shouldHideWhiteRim ? "20px" : "20px";
      let t12;
      if ($[0] !== t10 || $[1] !== t11 || $[2] !== t7 || $[3] !== t8 || $[4] !== t9) {
        t12 = {
          fontSize: t7,
          fontWeight: FontWeights.Regular,
          avatarSize: t8,
          avatarMargin: t9,
          innerWrapperSize: t10,
          innerWrapperOffset: "2px",
          wrapperSize: t11
        };
        $[0] = t10;
        $[1] = t11;
        $[2] = t7;
        $[3] = t8;
        $[4] = t9;
        $[5] = t12;
      } else {
        t12 = $[5];
      }
      t6 = t12;
      break bb0;
    }
    if (size === "small") {
      const t7 = initials.length <= 2 ? "12px" : "10px";
      const t8 = shouldHideWhiteRim ? "36px" : "28px";
      const t9 = shouldHideWhiteRim ? "2px" : "4px";
      const t10 = shouldHideWhiteRim ? "0px" : "32px";
      const t11 = shouldHideWhiteRim ? "40px" : "36px";
      let t12;
      if ($[6] !== t10 || $[7] !== t11 || $[8] !== t7 || $[9] !== t8 || $[10] !== t9) {
        t12 = {
          fontSize: t7,
          fontWeight: FontWeights.Regular,
          avatarSize: t8,
          avatarMargin: t9,
          innerWrapperSize: t10,
          innerWrapperOffset: "2px",
          wrapperSize: t11
        };
        $[6] = t10;
        $[7] = t11;
        $[8] = t7;
        $[9] = t8;
        $[10] = t9;
        $[11] = t12;
      } else {
        t12 = $[11];
      }
      t6 = t12;
      break bb0;
    }
    if (size === "medium") {
      const t7 = initials.length <= 2 ? "16px" : "14px";
      const t8 = shouldHideWhiteRim ? "44px" : "40px";
      const t9 = shouldHideWhiteRim ? "2px" : "4px";
      const t10 = shouldHideWhiteRim ? "0px" : "44px";
      let t11;
      if ($[12] !== t10 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
        t11 = {
          fontSize: t7,
          fontWeight: FontWeights.Regular,
          avatarSize: t8,
          avatarMargin: t9,
          innerWrapperSize: t10,
          innerWrapperOffset: "2px",
          wrapperSize: "48px"
        };
        $[12] = t10;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = t11;
      } else {
        t11 = $[16];
      }
      t6 = t11;
      break bb0;
    }
    if (size === "x-large") {
      const t7 = shouldHideWhiteRim ? "100px" : "86px";
      const t8 = shouldHideWhiteRim ? "4px" : "11px";
      const t9 = shouldHideWhiteRim ? "0px" : "98px";
      let t10;
      if ($[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
        t10 = {
          fontSize: "35px",
          fontWeight: "500",
          avatarSize: t7,
          avatarMargin: t8,
          innerWrapperSize: t9,
          innerWrapperOffset: "5px",
          wrapperSize: "108px"
        };
        $[17] = t7;
        $[18] = t8;
        $[19] = t9;
        $[20] = t10;
      } else {
        t10 = $[20];
      }
      t6 = t10;
      break bb0;
    }
    const t7 = initials.length <= 2 ? "22px" : "20px";
    const t8 = shouldHideWhiteRim ? "54px" : "52px";
    const t9 = shouldHideWhiteRim ? "3px" : "4px";
    const t10 = shouldHideWhiteRim ? "0px" : "56px";
    let t11;
    if ($[21] !== t10 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
      t11 = {
        fontSize: t7,
        fontWeight: "500",
        avatarSize: t8,
        avatarMargin: t9,
        innerWrapperSize: t10,
        innerWrapperOffset: "2px",
        wrapperSize: "60px"
      };
      $[21] = t10;
      $[22] = t7;
      $[23] = t8;
      $[24] = t9;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    t6 = t11;
  }
  const avatarProps = t6;
  let t7;
  if ($[26] !== avatarProps.wrapperSize) {
    t7 = {
      position: "relative",
      width: avatarProps.wrapperSize,
      minWidth: avatarProps.wrapperSize,
      height: avatarProps.wrapperSize
    };
    $[26] = avatarProps.wrapperSize;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      borderRadius: "50%"
    };
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== shouldUseSimplifiedAvatar) {
    t9 = <Box component="div" style={t8} sx={theme => ({
      background: shouldUseSimplifiedAvatar ? "none" : theme.vars.palette.gradients.brand
    })} />;
    $[29] = shouldUseSimplifiedAvatar;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== avatarProps.innerWrapperOffset || $[32] !== avatarProps.innerWrapperSize) {
    t10 = <Box component="div" style={{
      position: "absolute",
      top: avatarProps.innerWrapperOffset,
      left: avatarProps.innerWrapperOffset,
      width: avatarProps.innerWrapperSize,
      height: avatarProps.innerWrapperSize,
      borderRadius: "50%"
    }} sx={_temp} />;
    $[31] = avatarProps.innerWrapperOffset;
    $[32] = avatarProps.innerWrapperSize;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== avatarProps.avatarMargin || $[35] !== avatarProps.avatarSize) {
    t11 = {
      position: "absolute",
      width: avatarProps.avatarSize,
      height: avatarProps.avatarSize,
      marginLeft: avatarProps.avatarMargin,
      marginTop: avatarProps.avatarMargin
    };
    $[34] = avatarProps.avatarMargin;
    $[35] = avatarProps.avatarSize;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== avatarProps.avatarSize || $[38] !== avatarProps.fontSize || $[39] !== avatarProps.fontWeight) {
    t12 = {
      width: avatarProps.avatarSize,
      height: avatarProps.avatarSize,
      fontSize: avatarProps.fontSize,
      fontWeight: avatarProps.fontWeight,
      letterSpacing: "0.6px"
    };
    $[37] = avatarProps.avatarSize;
    $[38] = avatarProps.fontSize;
    $[39] = avatarProps.fontWeight;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== icon || $[42] !== iconColor) {
    t13 = icon && <Box component="span" sx={{
      display: "flex",
      alignItems: "center",
      ...getSvgColoredIconCss(iconColor)
    }}>{icon}</Box>;
    $[41] = icon;
    $[42] = iconColor;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== icon || $[45] !== initials) {
    t14 = !icon && <var>{initials}</var>;
    $[44] = icon;
    $[45] = initials;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== backgroundColor || $[48] !== initials || $[49] !== src || $[50] !== t12 || $[51] !== t13 || $[52] !== t14) {
    t15 = <Avatar bgColor={backgroundColor} sx={t12} src={src} alt={initials}>{t13}{t14}</Avatar>;
    $[47] = backgroundColor;
    $[48] = initials;
    $[49] = src;
    $[50] = t12;
    $[51] = t13;
    $[52] = t14;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== t11 || $[55] !== t15) {
    t16 = <Box component="div" style={t11}>{t15}</Box>;
    $[54] = t11;
    $[55] = t15;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  let t17;
  if ($[57] !== t10 || $[58] !== t16 || $[59] !== t7 || $[60] !== t9) {
    t17 = <Box component="div" style={t7}>{t9}{t10}{t16}</Box>;
    $[57] = t10;
    $[58] = t16;
    $[59] = t7;
    $[60] = t9;
    $[61] = t17;
  } else {
    t17 = $[61];
  }
  return t17;
}
function _temp(theme_0) {
  return {
    background: theme_0.vars.palette.Avatar.insideBorder
  };
}